/**
 * TanStack Router: /performance/feedbacks/complete
 *
 * This route file was auto-generated by the route generation script.
 * Component: PerformanceFeedbacksCompletePage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import PerformanceFeedbacksCompletePage from '@/app/performance/feedbacks/complete/page'

/**
 * Route: /performance/feedbacks/complete
 * Layout: _auth (authenticated)
 * Component: PerformanceFeedbacksCompletePage
 */
export const Route = createFileRoute('/_auth/performance/feedbacks/complete')({
  component: PerformanceFeedbacksCompletePage,
})
